import { render, staticRenderFns } from "./TemplateMappingTable.vue?vue&type=template&id=50e8f5ac&scoped=true&"
import script from "./TemplateMappingTable.vue?vue&type=script&lang=js&"
export * from "./TemplateMappingTable.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMappingTable.vue?vue&type=style&index=0&id=50e8f5ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8f5ac",
  null
  
)

export default component.exports